export const createSelectorFromUtil = (util, transformState) => (reduxState, ...args) => util(transformState(reduxState), ...args);